import { autoinject } from "aurelia-framework";
import { MepInsightsRequest, 
    MepGetInsightsTopContributorsToEmissionsResponse, 
    MepGetInsightsSmallestContributorsToEmissionsResponse, 
    MepGetInsightsVesselEmissionsComparedWithTargetResponse, 
    MepGetInsightsCorrelationWithPortCallsAndTimeResponse, 
    MepGetInsightsEmissionsByMonthResponse,
    MepGetInsightsLongTermForecastResponse} from "../../models/mep/mep-insights.models";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/mep/mep-insights.constants";

@autoinject()
export class MepInsightsService {
    constructor(private requestClient: RequestClientService) {}

    public getMepInsightsTopContributorsToEmissions(request: MepInsightsRequest) : Promise<MepGetInsightsTopContributorsToEmissionsResponse> {
        return this.requestClient.get<MepGetInsightsTopContributorsToEmissionsResponse>(`${Urls.GetTopContributorsToEmissions}`, request);
    }

    public getMepInsightsSmallestContributorsToEmissions(request: MepInsightsRequest) : Promise<MepGetInsightsSmallestContributorsToEmissionsResponse> {
        return this.requestClient.get<MepGetInsightsSmallestContributorsToEmissionsResponse>(`${Urls.GetSmallestContributorsToEmissions}`, request);
    }

    public getMepInsightsVesselEmissionsComparedWithTarget(request: MepInsightsRequest) : Promise<MepGetInsightsVesselEmissionsComparedWithTargetResponse> {
        return this.requestClient.get<MepGetInsightsVesselEmissionsComparedWithTargetResponse>(`${Urls.GetVesselEmissionsComparedWithTarget}`, request);
    }

    public getMepInsightsCorrelationWithPortCallsAndTime(request: MepInsightsRequest) : Promise<MepGetInsightsCorrelationWithPortCallsAndTimeResponse> {
        return this.requestClient.get<MepGetInsightsCorrelationWithPortCallsAndTimeResponse>(`${Urls.GetCorrelationWithPortCallsAndTime}`, request);
    }

    public getMepInsightsEmissionsByMonth(request: MepInsightsRequest) : Promise<MepGetInsightsEmissionsByMonthResponse> {
        return this.requestClient.get<MepGetInsightsEmissionsByMonthResponse>(`${Urls.GetEmissionsByMonth}`, request);
    }

    public getMepInsightsLongTermForecast(request: MepInsightsRequest) : Promise<MepGetInsightsLongTermForecastResponse> {
        return this.requestClient.get<MepGetInsightsLongTermForecastResponse>(`${Urls.GetLongTermForecast}`, request);
    }
}